import { render } from "./HouseLayout.vue?vue&type=template&id=462f6138"
import script from "./HouseLayout.vue?vue&type=script&lang=js"
export * from "./HouseLayout.vue?vue&type=script&lang=js"

import "./HouseLayout.vue?vue&type=style&index=0&id=462f6138&lang=css"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\ametist.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__